import handleResponse from './handleResponse';

export default handleResponse;
